import { render, staticRenderFns } from "./videoAndShare.vue?vue&type=template&id=8f7e961a"
import script from "./videoAndShare.vue?vue&type=script&lang=js"
export * from "./videoAndShare.vue?vue&type=script&lang=js"
import style0 from "./videoAndShare.vue?vue&type=style&index=0&id=8f7e961a&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports